<template>
  <div>
    <button
      v-on="listeners"
      v-bind="attrs"
      :type="type"
      :class="[setTheme, modeClasses, isLoading, { disabled: disabled, 'has-group': group }]"
      :disabled="disabled"
      class="lcbutton --start-common-classes focus:outline-none group flex rounded-md items-center w-full px-2 py-2 text-sm --end-common-classes">
      <slot/>
    </button>
  </div>
</template>
<script>
export default {
  name: 'item-nav',
  inheritAttrs: false,
  props: {
    type: {
      type: String,
      default: 'button'
    },
    theme: {
      type: String,
      default: 'light'
    },
    loading: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    group: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    listeners: function () {
      return {
        ...this.$listeners
      }
    },
    attrs: function () {
      return {
        ...this.$attrs
      }
    },
    setTheme: function () {
      return {
        '--start-light-classes bg-white hover:bg-primary-50 hover:text-primary --end-light-classes':
          this.theme === 'light',
        '--start-light--active-classes active:bg-primary-100 --end-light--active-classes':
          this.theme === 'light' && !this.disabled,
        '--start-dark-classes bg-secondary-800 dark:bg-darkblue-900 text-white hover:bg-secondary-900 dark:hover:bg-darkblue focus:bg-secondary-900 dark:focus:bg-darkblue --end-dark-classes':
          this.theme === 'dark',
        '--start-dark--active-classes active:bg-secondary dark:active:bg-darkblue-600 dark:active:text-primary --end-dark--active-classes':
          this.theme === 'dark' && !this.disabled,
        '--start-primary-classes bg-primary-600 text-white hover:bg-primary-500 focus:bg-primary-500 --end-primary-classes':
          this.theme === 'primary',
        '--start-primary--active-classes active:bg-primary-500 --end-primary--active-classes':
          this.theme === 'primary' && !this.disabled,
      }
    },
    isLoading: function () {
      return { 'loader-in-element': this.loading }
    },
    modeClasses: function () {
      return {
        'lcbutton--light': this.theme === 'light',
        'lcbutton--dark': this.theme === 'dark',
        'lcbutton--primary': this.theme === 'primary',
      }
    },
  }
}
</script>
<style lang="scss" scoped>
  .lcbutton {
    @apply focus:outline-none flex rounded-md items-center w-full px-2 py-2 text-sm;
    &.lcbutton--light {
      @apply bg-white;
      &:focus-visible, &:hover {
        @apply bg-primary-50 text-primary;
      }
      &:active:not(.disabled) {
        @apply bg-primary-100;
      }
    }
    &.lcbutton--dark {
      @apply bg-secondary-800 dark:bg-darkblue-900 text-white;
      &:focus-visible, &:hover {
        @apply bg-secondary-900 dark:bg-darkblue;
      }
      &:active:not(.disabled) {
        @apply bg-secondary dark:bg-darkblue-600 dark:text-primary;
      }
    }
    &.lcbutton--primary {
      @apply bg-primary-600 text-white;
      &:focus-visible, &:hover {
        @apply bg-primary-500;
      }
      &:active:not(.disabled) {
        @apply bg-primary-500;
      }
    }
    &.disabled {
      cursor: not-allowed !important;
    }
  }
</style>
